import { loginOrg } from '@/utils/LoginContext';
import request from '@/utils/request';
import { stringify } from 'qs';
export async function receive(params) {
  return request(`/iwms-wms/wms/receive/receive`, {
    method: 'POST',
    body: params,
  });
}

export async function verifyContainer(params) {
  return request(`/iwms-wms/wms/receive/verifyContainer`, {
    method: 'POST',
    body: params
  });
}

export async function verifyArticle(params) {
  return request(`/iwms-wms/wms/receive/verifyArticle?companyUuid=${params.companyUuid}&dcUuid=${params.dcUuid}&orderBillNumber=${params.orderBillNumber}&articleBarcode=${params.articleBarcode}`, {
    method: 'POST'
  });
}

export async function verifyOrderBillOrInwrhBill(params) {
  return request(`/iwms-wms/wms/receive/verifyReceive?billNumber=${params.billNumber}&dcUuid=${loginOrg().uuid}&receiveType=${params.receiveType}`, {
    method: 'POST',
  });
}

export async function getReceivabelOrderBillOrInwrhBillNumber(params) {
  return request(`/iwms-wms/wms/receive/queryReceivableBillNumbers?billNumber=${params.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  });
}

export async function queryReceiveBillItem(params) {
  return request(`/iwms-wms/wms/receive/queryOrderBills?billNumber=${params.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  });
}

export async function endReceive(params) {
  return request(`/iwms-wms/wms/receive/endReceive?dcUuid=${loginOrg().uuid}`, {
    method: 'POST',
    body: params.billNumbers
  });
}

export async function queryInProgress(params) {
  return request(`/iwms-wms/wms/receive/queryInProgress?billNumber=${params.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  });
}

export async function fetchPrintContainer(params) {
  return request(`/iwms-wms/wms/receive/fetchPrintContainer`, {
    method: 'POST',
    body: params
  });
}
//生鲜收货模块查询质检结果
export async function getSense(params) {
  return request(`/iwms-wms/wms/receive/getSenseByArticleUuid?${stringify(params)}`, {
    method: 'GET'
  });
}

//web收货模块查询订单
export async function queryOrderBillsByBillNum(params) {
  return request(`/iwms-wms/wms/receive/queryOrderBillsByBillNum?dcUuid=${params.dcUuid}&billNumber=${params.billNumber}`, {
    method: 'GET'
  });
}